/**
 * @author      hugo@zumper.com (Hugo Pineda)
 * @copyright   Copyright (c) 2021, Zumper
 */

import {
  Modal as ChakraModal,
  ModalProps as ChakraModalProps,
  ResponsiveValue,
} from '@chakra-ui/react'
import { useResponsiveValue } from '@zcode-ui/controls'
import React, { createContext } from 'react'

type UnresponsiveValue<T extends ResponsiveValue<unknown>> = T extends ResponsiveValue<infer S>
  ? S
  : never

interface ModalContextProps {
  customWidth?: string
  isCentered?: boolean
  size: UnresponsiveValue<ChakraModalProps['size']>
}

export const ModalContext = createContext<ModalContextProps>({
  size: 'md',
  isCentered: true,
})

export interface ModalProps extends ChakraModalProps {
  customWidth?: string
}

export const Modal = ({ isCentered = true, ...props }: ModalProps) => {
  const context = {
    customWidth: props.customWidth,
    isCentered,
    size: useResponsiveValue(props.size) ?? undefined,
  }
  return (
    <ModalContext.Provider value={context}>
      <ChakraModal {...props} />
    </ModalContext.Provider>
  )
}
